import { DatePipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  NgZone,
  AfterViewInit,
  Input,
  HostListener,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';

import * as mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { DataService } from 'src/app/services/data/data.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { MapService } from '../../services/map/map.service';
import { MapboxMapSync } from './mapbox-map-sync';
import { interval, Subject } from 'rxjs';
import { debounce, takeUntil } from 'rxjs/operators';
import { LocationUIService } from 'src/app/services/location-ui/location-ui.service';
import { PotreeCesiumViewerService } from '../potree-cesium-viewer/potree-cesium-viewer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LayerStoreService } from 'src/app/stores/layer-store/layer-store.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { AnnotationStoreService } from 'src/app/stores/annotation-store/annotation-store.service';
import { GenericTypeStoreService } from 'src/app/stores/generic-types-store/generic-type-store.service';
import { GalleryImagesStoreService } from 'src/app/stores/gallery-images-store/gallery-images-store.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

declare var $;

export interface MapView {
  view: string;
  map: mapboxgl.Map;
  draw: MapboxDraw;
  ortho?: any;
  selectedAnnotation?: any;
  /** Contains the severity filter toggle setting for each mapview */
  severityFilter?: { [severityId: string]: boolean };
}

@Component({
  selector: 'app-split-view',
  templateUrl: './split-view.component.html',
  styleUrls: ['./split-view.component.sass'],
})
export class SplitViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() onBaseMapLoaded: Function;
  @Input() onBaseMapReady: Function;
  @Input() onNewMapAdded: Function;
  @Input() onLastMapRemoved: Function;

  @ViewChild('videoBox') videoBox: ElementRef;
  @ViewChild('videoPlayer') videoPlayer: ElementRef;

  // _views: string[] = ["map-container-0"]; // initial map container
  mapViews: MapView[] = [];
  // _maps: mapboxgl.Map[] = [];
  // _draws: MapboxDraw[] = [];
  // _orthos = [];
  _initMap: mapboxgl.Map;
  _mapboxSync: MapboxMapSync;
  selectedMapIdx = 0;
  _isAddingMap = false;
  isZooming = false;

  _mapStyles: any[] = [
    {
      style: 'mapbox://styles/intuitivebadger/ckfdel5j40z8p19o6o0xu05sd',
      accessToken:
        'pk.eyJ1IjoiaW50dWl0aXZlYmFkZ2VyIiwiYSI6ImNrOXZpeXZiNzBkN3Iza29saHhjOWo2OGwifQ.QOMbmOzi8OhYw6NYyDqBRQ',
    },
    {
      style: 'mapbox://styles/amjadhashim/ckgjlrcda7js719qkkhsgdmpj',
      accessToken:
        'pk.eyJ1IjoiYW1qYWRoYXNoaW0iLCJhIjoiY2s3dTNhbXV3MDBhMDNldGpsdjZ0YzRyOSJ9.JkG-uLB0yZvloC06gcS-Eg',
    },
  ];

  MAX_MAP_VIEW_COUNT: number = 2;
  ALTERNATE_MAP_STYLE: boolean = false;

  _referencedCards: any[] = [
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
    {
      bgUrl:
        'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/imgBuilding5/DJI_0437.JPG',
    },
  ];

  markerVideoUrl = 'https://aerodyne-evoteq.s3.me-south-1.amazonaws.com';

  lastCardOverId: number = -1;
  disableChangeMap: boolean = false;

  // keydown event listener for map draw grid mouse over mode
  @HostListener('window:keydown', ['$event'])
  keyDownEvent(event: KeyboardEvent) {
    if (event.key == 'Shift') {
      this.mapService.isShiftKeyDown$.next(true);
    }
  }

  // keydown event listener for map draw grid mouse over mode
  @HostListener('window:keyup', ['$event'])
  keyUpEvent(event: KeyboardEvent) {
    this.mapService.isShiftKeyDown$.next(false);
  }

  constructor(
    private zone: NgZone,
    private splitViewService: SplitViewService,
    public mapService: MapService,
    private datePipe: DatePipe,
    private titlecasePipe: TitleCasePipe,
    private dataService: DataService,
    private locationUiService: LocationUIService,
    private layerStore: LayerStoreService,
    private potreeCesiumViewerService: PotreeCesiumViewerService,
    private spinner: NgxSpinnerService,
    private locationStore: LocationStoreService,
    private annotationStore: AnnotationStoreService,
    private genericTypeStore: GenericTypeStoreService,
    private galleryImagesStore: GalleryImagesStoreService,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private _t: TranslateService
  ) {}

  ngOnInit(): void {
    // this.splitViewService._mapboxSync = new MapboxMapSync(this.zone);
    this._mapboxSync = new MapboxMapSync(this.zone);

    this.splitViewService.onEvent$.subscribe((res) => {
      switch (true) {
        case res.onClickAdd:
          this.onClickAdd(res);
          break;
        case res.onResetMapLayer:
          this.onResetMapLayer();
          break;
        case res.onCardAnnotClicked:
          this.onCardAnnotClicked(res);
          break;
        case res.onClickRemove:
          this.onClickRemove();
          break;
        case res.onClickUnsync:
          this.onClickUnsync();
          break;
        case res.onAddOrtho:
          this.onAddOrtho(res, res.skipZoom);
          break;
        case res.onClickResync:
          this.onClickResync();
          break;
        case res.onClickResetBearing:
          this.onClickResetBearing();
          break;
        case res.onClickResetPitch:
          this.onClickResetPitch();
          break;
        case res.onFitBounds:
          this.onFitBounds(res.bounds, res.offset);
          break;
        case res.refreshAnchorButton:
          this.refreshAnchorButton();
          break;
        case res.onRemoveAllSplitScreen:
          this.onRemoveAllSplitScreen();
          break;
        default:
          break;
      }
    });

    this.mapService.markerEvents$
      .pipe(debounce(() => interval(100)))
      .subscribe((events) => {
        if (events.onMarkerEnter) {
          const evt = events.onMarkerEnter;
          this.showVideo({
            show: true,
            xYPosition: [evt.mouseEvent.clientX, evt.mouseEvent.clientY],
            videoUrl: `${this.markerVideoUrl}/${evt.markerTitle}.mp4`,
          });
        } else if (events.onMarkerLeave) {
          const evt = events.onMarkerLeave;
          this.showVideo({ show: false });
        } else if (events.onMarkerClick) {
          const evt = events.onMarkerClick;
          this.showVideo({ show: false });
        }
      });

    this.mapService.hasDrawing$.subscribe(
      (res) => (this.disableChangeMap = res)
    );

    this.splitViewService.onEvent$.subscribe((res) => {
      if (res.onAddOrtho) {
        this._initMap.on('dragstart', this.checkZoomtoOrtho());
      }
    });

    const mapView: MapView = {
      view: 'map-container-0',
      map: null,
      draw: this.mapService.draw,
    };
    this.mapViews = [mapView];
    this.splitViewService.mapViews = this.mapViews;
    this.splitViewService.selectedMapViewIndex = this.selectedMapIdx;

    this.locationStore.currLocation$.subscribe((currLocation) => {
      if (!this.mapService.isMapLoaded$.getValue()) return;
      if (!this.splitViewService.isSplitscreenOn) return;
      if (!currLocation.id)
        for (let i = 0; i < this.mapViews.length; i++) {
          this.mapViews[i].ortho = null;
          document.getElementById('split-view-anchor-button-' + i).innerHTML =
            this._t.instant('Click to make this active layer');
        }
    });
  }

  onRemoveAllSplitScreen() {
    if (this.mapViews.length == 1) return;
    while (this.mapViews.length !== 1) {
      this.mapViews.pop();
    }
    this.onSelectMap(0);
    this.splitViewService.isSplitscreenOn = false;
    this._mapboxSync.startSync(this.maps);
    this.onLastMapRemoved();
  }

  onFitBounds(bounds: any, offset: any) {
    this.mapViews.forEach((mapView) => {
      mapView.map.fitBounds(bounds, offset);
    });
  }

  onClickResetPitch() {
    for (const mapView of this.mapViews) {
      mapView.map.easeTo({
        pitch: 0,
        easing: this._easing.bind(this),
      });
    }
  }

  onClickResetBearing() {
    for (const mapView of this.mapViews) {
      mapView.map.easeTo({
        bearing: 0,
        easing: this._easing.bind(this),
      });
    }
  }

  _easing(t) {
    return t * (2 - t);
  }

  ngAfterViewInit(): void {
    const map = new mapboxgl.Map({
      container: 'map-container-0',
      style: this.getMapStyle().style,
      accessToken: this.getMapStyle().accessToken,
      zoom: 4,
      center: [0, 0],
      pitch: 60,
      preserveDrawingBuffer: true,
      workerCount: 6,
    });
    map.setMaxZoom(23.99);
    map.on('load', (e) => {
      //add images

      map.loadImage(
        '/assets/drone-poi-marker/Icon_ClusterBoundary.png',
        (error, image) => {
          if (error) throw error;
          map.addImage('gallery-image-marker', image);
        }
      );
      map.loadImage(
        '/assets/drone-poi-marker/Icon_arrow marker.png',
        (error, image) => {
          if (error) throw error;
          map.addImage('gallery-image-marker-arrow', image);
        }
      );

      const containerId = e.target._container.id;
      $('#' + containerId)
        .find('.curtain')
        .css('opacity', 0);
      $('#' + containerId)
        .find('.curtain')
        .on(
          'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
          () => {
            $('#' + containerId)
              .find('.curtain')
              .remove();
          }
        );
      if (this.onBaseMapLoaded) {
        this.onBaseMapLoaded(map); // fire on onBaseMapLoaded callback
      }
    });

    map.on('error', this.suppressError);

    this.onBaseMapReady(map);
    // this._maps.push(map);

    this.mapViews[0].map = map;

    const hasDraw$ = new Subject<any>();
    this.mapService.drawBuilt$
      .pipe(takeUntil(hasDraw$.asObservable()))
      .subscribe((status) => {
        if (status) {
          // const mapView: MapView = {
          // 	view: "map-container-0",
          // 	map: map,
          // 	draw: this.mapService.draw,
          // 	orthoToggle: true,
          // 	gridToggle: true,
          // 	sateliteToggle: false,
          // 	imagesMarkerToggle: false,
          // }
          // this.mapViews = [mapView]
          this.mapViews[0].draw = this.mapService.draw;

          // mapView.draw = this.mapService.draw
          // this._draws.push(this.mapService.draw);
          hasDraw$.next();
          hasDraw$.unsubscribe();
        }
      });

    this.splitViewService.onEvent$.next({
      _maps: this.mapViews.map((mapView) => mapView.map),
    });
    this.splitViewService.MAX_MAP_VIEW_COUNT = this.MAX_MAP_VIEW_COUNT;
    this._initMap = map;
  }

  suppressError(e: any) {
    const FILTER = {
      message: 'Forbidden',
      name: 'e',
      status: 403,
      url: 's3',
    };
    /** Forbidden errors will need to be suppressed here */
    const err = e.error;
    if (
      err.message === FILTER.message &&
      err.name === FILTER.name &&
      err.url.includes(FILTER.url)
    )
      return;
    /** Emit other mapbox error as console error */ else
      console.error('map.onError.err:', err);
  }

  getMapStyle(): any {
    if (this.ALTERNATE_MAP_STYLE) {
      if (this.mapViews.length % 2 == 0) {
        return this._mapStyles[0];
      } else {
        return this._mapStyles[1];
      }
    } else {
      return this._mapStyles[0];
    }
  }

  checkZoomtoOrtho() {
    this.isZooming = !this.isZooming;

    setTimeout(() => {
      this.isZooming = !this.isZooming;
      this._initMap.off('dragstart');
    }, 1000);
  }

  onClickAdd(res) {
    this.spinner.show();
    if (this._isAddingMap) return;
    this._isAddingMap = true;
    this.splitViewService.onEvent$.next({ isSplitscreenOn: true });
    this.splitViewService.isSplitscreenOn = true;
    if (this.mapViews.length >= this.MAX_MAP_VIEW_COUNT) {
      return;
    }

    const mapIndex = this.mapViews.length;
    const view = 'map-container-' + mapIndex;

    // initial new Map state
    const mapView: MapView = {
      view: view,
      map: null,
      draw: null,
      ortho: null,
      selectedAnnotation: null,
    };

    this.mapViews.push(mapView);

    setTimeout(() => {
      // this trigger ONLY when splitscreen initated
      // if (this.mapViews.length === 1) {
      // 	const topMostOrthoMapLayer = this.mapService.$topMostOrthoMapLayer.getValue()

      // 	document.getElementById(
      // 		'split-view-anchor-button-' + this.selectedMapIdx
      // 	).innerHTML =
      // 		this.titlecasePipe.transform(topMostOrthoMapLayer['layer_type']) +
      // 		' - ' +
      // 		this.datePipe.transform(topMostOrthoMapLayer['layer_date'], 'dd/MM/yyyy');

      // 	/** start: re-init latest ortho and annot */
      // 	const orthoLayer = this.locationStore.currLocation$.getValue().map_layer_ortho
      // 	if (orthoLayer) {
      // 		this.mapService.addOrtho(
      // 			orthoLayer,
      // 			'split-view',
      // 			this.mapViews[0].map
      // 		);
      // 		this.mapViews[0].ortho = orthoLayer
      // 		// this._orthos.push(orthoLayer)
      // 		this.splitViewService.selectedOrtho = orthoLayer
      // 		//draw annotation
      let map_annot = this.annotationStore.annotations$
        .getValue()
        .filter((i) => {
          if (i.map_layer && i.map_layer.id === this.mapViews[0].ortho['id']) {
            return i;
          }
        });
      this.mapService.toggleAllAnnotation(
        true,
        this.mapViews[0].map,
        map_annot,
        true
      );
      // 	}
      // 	/** end: re-init latest ortho and annot */
      // }

      const map = new mapboxgl.Map({
        container: view,
        style: this.getMapStyle().style,
        accessToken: this.getMapStyle().accessToken,
        zoom: this._initMap.getZoom(),
        center: [this._initMap.getCenter().lng, this._initMap.getCenter().lat],
        pitch: this._initMap.getPitch(),
        bearing: this._initMap.getBearing(),
        preserveDrawingBuffer: true,
      });

      const draw = this.mapService.buildDraw(
        this.genericTypeStore.severityList,
        map
      );

      mapView.map = map;
      mapView.draw = draw;

      // this._draws.push(this.mapService.buildDraw(this.genericTypeStore.severityList, map))
      // this._maps.push(map);

      // add marker to all maps
      this.dataService.allVisibleMarkers$?.subscribe((location) => {
        this.mapViews.forEach((view) => {
          this.mapService.makeMarkers(location, view.map);
        });
      });

      this.onNewMapAdded(map);

      map.setMaxZoom(23.99);

      map.once('load', (e) => {
        const containerId = e.target._container.id;
        $('#' + containerId)
          .find('.curtain')
          .css('opacity', 0);
        $('#' + containerId)
          .find('.curtain')
          .on(
            'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
            () => {
              $('#' + containerId)
                .find('.curtain')
                .remove();
            }
          );
        // this.testOrthoComparison(map);
        this.splitViewService.onEvent$.next({
          onAddOrtho: true,
          skipZoom: res.skipZoom,
          orthoLayer: res.orthoLayer,
        });
        // this.onAddOrtho(res, res.skipZoom)
      });
      map.on('error', this.suppressError);

      const allMaps = this.maps;

      this._mapboxSync.startSync(allMaps);

      this.onSelectMap(mapIndex);
      this.spinner.hide();
      this._isAddingMap = false;
      this.refreshAnchorButton();
    }, 100);
  }

  testOrthoComparison(map: mapboxgl.Map) {
    //const orthoUrl = "https://aerodyne-suntory.s3-ap-northeast-1.amazonaws.com/05StorageBuilding16December2019/Processed/Maptiler/Ortho+Maptiler/05StorageBuilding16December2019/openlayers.html";
    const orthoUrl =
      'https://aerodyne-suntory.s3.ap-northeast-1.amazonaws.com/FIX16/openlayers.html';
    const source = {
      type: 'raster',
      tiles: [orthoUrl.replace(/(?=\w+\.\w{3,4}$).+/, '{z}/{x}/{y}.png')],
      tileSize: 512,
      maxzoom: 24,
    };
    const layer = {
      id: 'compare-ortho-layer',
      type: 'raster',
      source: source,
      maxzoom: 24,
    };
    map.addSource('compare-ortho-source', source);
    map.addLayer(layer, 'contour-label');
  }

  onClickRemove() {
    const removedIndex = this.mapViews.length - 1;
    this.mapViews.pop();
    // this._draws.pop();
    // this._views.pop();
    // this._maps.pop();
    // if (this._orthos[removedIndex]) this._orthos.pop()
    if (this.mapViews.length === 1) {
      this.onSelectMap(0);
      this.splitViewService.isSplitscreenOn = false;
      this.locationUiService.refreshCurrLocation(
        this.locationStore.currLocation$.getValue().id
      );
    } else {
      this.onSelectMap(removedIndex - 1);
    }
    // update sync
    this._mapboxSync.startSync(this.maps);

    this.onLastMapRemoved();
  }

  onClickUnsync() {
    this._mapboxSync.stopSync();
  }

  onClickResync() {
    this._mapboxSync.startSync(this.maps);
    this._mapboxSync.syncOnce(); // trigger sync once to update all maps
  }

  getViewOffset(index, forcePositive: boolean = false): string {
    let offset = 0;
    if (index == 0) {
      return offset + 'px';
    } else {
      const parent = $('#map-container-' + (index - 1)).parent();

      const w = $(parent).width() + $(parent).offset().left;
      // 21 is the border width (5 + 5) + divider/curtain width
      offset = !forcePositive ? -(w + 21) : w + 21;
      return offset + 'px';
    }
  }

  get maps(): mapboxgl.Map[] {
    return this.mapViews.map((mapView) => mapView.map); // get all active maps
  }

  get views(): mapboxgl.Map[] {
    return this.mapViews.map((mapView) => mapView.view); // get all active maps
  }

  get viewsIds(): Array<string> {
    return this.mapViews.map((mapView) => mapView.view); // get all views container ids
  }

  onSelectMap = (k) => {
    if (this.disableChangeMap || this.splitViewService.isEditingAnnotation) {
      return;
    }
    if (k === this.selectedMapIdx && !this.splitViewService.isEditingAnnotation)
      return this.splitViewService.onEvent$.next({ toggleTimeLine: true });

    for (const map of this.maps) {
      this.mapService.removeAllGrid(map);
    }
    this.selectedMapIdx = k;
    this.mapService.map = this.mapViews[k].map;
    this.mapService.draw = this.mapViews[k].draw;
    // this.splitViewService.selectedOrtho = this.mapViews[k].ortho
    this.splitViewService.selectedMapViewIndex = this.selectedMapIdx;
    this.splitViewService.onEvent$.next({
      onActiveMapChange: {
        map_layer: this.mapViews[k].ortho,
        map: this.mapViews[k].map,
      },
    });
  };

  onCardAnnotClicked(res) {
    this._mapboxSync._masterMap.next(this.mapViews[this.selectedMapIdx].map);
    this.onAddOrtho(res, true);
  }

  onResetMapLayer() {
    if (!this.mapService.isMapLoaded$.getValue()) return;

    this.maps.forEach((map) => {
      if (map.getLayer('split-view')) map.removeLayer('split-view');
      this.mapService.map = map;
      this.layerStore.resetMapLayer();
      this.mapService.toggleAllAnnotation(false, map, undefined);
      this.potreeCesiumViewerService.unloadAllPointClouds();
      this.annotationStore.annotations$.next([]);
      this.galleryImagesStore.galleryImages$.next([]);
      this.galleryImagesStore.galleryImagesCurrentIdx$.next(0);
    });
  }

  ngOnDestroy(): void {
    // this._initMap.off('zoomend', this.checkZooming(true))
    // this._initMap.off('zoomstart', () =>{
    // 	this.isZooming = true;
    // 	// document.getElementsByClassName('split-container').
    // })
    // this._initMap.off('zoomend', () =>{
    // 	this.isZooming = false;
    // })
  }

  refreshAnchorButton() {
    for (let i = 0; i < this.mapViews.length; i++) {
      const doc = document.getElementById('split-view-anchor-button-' + i);
      if (doc && this.mapViews[i].ortho)
        doc.innerHTML =
          this.titlecasePipe.transform(this.mapViews[i].ortho['layer_type']) +
          ' - ' +
          this.datePipe.transform(
            this.mapViews[i].ortho['layer_date'],
            'dd/MM/yyyy'
          );
    }
  }

  async onAddOrtho(res, skipZoom = false) {
    if (this.mapViews.length === 1) {
      return;
    }
    this.spinner.show();
    const selectedMap = this.mapViews[this.selectedMapIdx].map;

    switch (res.orthoLayer.layer_type) {
      case 'geojson':
        const response = await fetch(res.orthoLayer.external_url);
        let geojson = await response.json();

        if (geojson.default) {
          for (let c = 0; c < geojson.default.features.length; c++) {
            if (res.orthoLayer.fill_color) {
              geojson.default.features[c].properties['_f_color'] =
                geojson.default.features[c].properties['_c_color'] =
                  res.orthoLayer.fill_color;
            }
            if (res.orthoLayer.line_color) {
              geojson.default.features[c].properties['_f_o_color'] =
                geojson.default.features[c].properties['_l_color'] =
                geojson.default.features[c].properties['_c_s_color'] =
                  res.orthoLayer.line_color;
            }
            if (res.orthoLayer.line_width) {
              geojson.default.features[c].properties['_l_width'] =
                geojson.default.features[c].properties['_c_s_width'] = parseInt(
                  res.orthoLayer.line_width
                );
            }
          }
        } else {
          for (let c = 0; c < geojson.features.length; c++) {
            if (res.orthoLayer.fill_color) {
              geojson.features[c].properties['_f_color'] = geojson.features[
                c
              ].properties['_c_color'] = res.orthoLayer.fill_color;
            }
            if (res.orthoLayer.line_color) {
              geojson.features[c].properties['_f_o_color'] =
                geojson.features[c].properties['_l_color'] =
                geojson.features[c].properties['_c_s_color'] =
                  res.orthoLayer.line_color;
            }
            if (res.orthoLayer.line_width) {
              geojson.features[c].properties['_l_width'] = geojson.features[
                c
              ].properties['_c_s_width'] = parseInt(res.orthoLayer.line_width);
            }
          }
        }

        this.mapService.loadGeoJsons(geojson, selectedMap, res.orthoLayer);
        break;

      default:
        this.mapService.removeAllOrtho();
        this.mapService.removeAllDSM();
        this.mapService.removeAllThermal();
        console.log('addOrtho1');
        this.mapService.addOrtho(res.orthoLayer, 'split-view', selectedMap);
        break;
    }

    this.mapViews[this.selectedMapIdx].ortho = res.orthoLayer;
    this.mapService.removeAllGrid(selectedMap);
    // this.splitViewService.selectedOrtho = res.orthoLayer
    this._mapboxSync._masterMap.next(selectedMap);
    setTimeout(() => {
      document.getElementById(
        'split-view-anchor-button-' + this.selectedMapIdx
      ).innerHTML =
        this.titlecasePipe.transform(res.orthoLayer.layer_type) +
        ' - ' +
        this.datePipe.transform(res.orthoLayer.layer_date, 'dd/MM/yyyy');

      //draw annotation
      let map_annot = this.annotationStore.annotations$
        .getValue()
        .filter((i) => {
          if (i.map_layer && i.map_layer.id === res.orthoLayer.id) {
            return i;
          }
        });
      this.mapService.toggleAllAnnotation(
        true,
        selectedMap,
        map_annot,
        skipZoom
      );
      this.spinner.hide();
    });
  }

  async showVideo(fnArgs: {
    show: boolean;
    xYPosition?: [number, number];
    videoUrl?: string;
  }) {
    const { show, xYPosition, videoUrl } = fnArgs;
    const videoElement = this.videoPlayer.nativeElement,
      videoContainer = this.videoBox.nativeElement;

    if (!show) {
      this.renderer.addClass(videoContainer, 'hidden');
      videoElement.pause();
      this.renderer.removeAttribute(videoElement, 'src');
      this.renderer.removeStyle(videoContainer, 'box-shadow');
    } else {
      /** Check for marker video presence before loading. This suppresses the HTML video load error */
      const validLocs = [
          '1B4210A(1)',
          '1A5310A(2)',
          '1A5320A(1)',
          '1A5320A(2)',
          '1A5320A(3)',
          '1B4210A(3)',
          '1B4230A',
        ],
        isValid = validLocs.some((name) => videoUrl.includes(name));

      if (videoElement && isValid) {
        this.renderer.setAttribute(
          videoElement,
          'src',
          videoUrl ||
            'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        );
        videoElement.muted = true;
        videoElement.loop = true;
        videoElement.play();

        const repositionContainerY = (top: number, videoHeight = 300) => {
          if (xYPosition[1] > window.innerHeight / 2)
            this.renderer.setStyle(
              videoContainer,
              'top',
              top - (videoHeight + 10) + 'px'
            );
          else this.renderer.setStyle(videoContainer, 'top', top + 'px');
        };
        const repositionContainerX = (left: number, videoWidth = 400) => {
          if (xYPosition[0] > window.innerWidth / 2)
            this.renderer.setStyle(
              videoContainer,
              'left',
              left - (videoWidth + 10) + 'px'
            );
          else this.renderer.setStyle(videoContainer, 'left', left + 10 + 'px');
        };

        const loadedMetadata = this.renderer.listen(
          videoElement,
          'loadedmetadata',
          () => {
            const vidHeight = videoElement.videoHeight,
              vidWidth = videoElement.videoWidth;

            const newHeight = `${(vidHeight / vidWidth) * 400}`;
            this.renderer.setAttribute(videoElement, 'height', newHeight);
            console.log('widthxheight: ', `400 x ${newHeight}`);

            if (xYPosition?.length) {
              repositionContainerX(xYPosition[0]);
              repositionContainerY(xYPosition[1], +newHeight);
            }

            this.renderer.removeClass(videoContainer, 'hidden');
            this.renderer.setStyle(
              videoContainer,
              'box-shadow',
              '0px 2px 5px 0px rgba(0, 0, 0, 0.25)'
            );

            loadedMetadata();
          }
        );
      }
    }
  }
}
